import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["FormattedMessage"] */ "/app/src/i18n/i18n-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["P"] */ "/app/src/shared/globals/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/globals/UiElements/Flex.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/globals/UiElements/HTMLRender.tsx");
